<template>
	<v-row no-gutters class="pb-2 show-detail-unit">
		<v-col cols="4">
			<h4 class="text-body-2 font-weight-bold">{{ columnName }}</h4>
		</v-col>
		<v-col cols="8">
			<slot name="value">
				<p class="text-body-2" v-text="value" />
			</slot>
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: {
		columnName: {
			type: String,
			required: true,
		},
		value: {
			type: null,
			required: false,
			default: "",
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
}
</script>